var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMusic = function SvgMusic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264.1,
    cy: 763.397,
    r: 137.099,
    strokeWidth: 34.0007
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.432,
    cy: 661.201,
    r: 137.099,
    strokeWidth: 34.0007
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.103 745.11L400.103 213.712L903.532 81V664.495",
    strokeWidth: 32.9039
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.974 387.004L907.37 264.711",
    strokeWidth: 34.0007
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMusic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/music.svg";